import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=13b35edc&scoped=true&"
import script from "./Benefit.vue?vue&type=script&lang=js&"
export * from "./Benefit.vue?vue&type=script&lang=js&"
import style0 from "./Benefit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Benefit.vue?vue&type=style&index=1&id=13b35edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b35edc",
  null
  
)

export default component.exports